export enum ClaimAttachmentStatus {
    New = 1,
    InProgress = 2,
    Success = 3,
    Failed = 4,
    PartiallyFailed = 5,
    Cancellation = 6,
    Canceled = 7,
}